import type React from 'react';
import { Icon } from '../../shared';
import styles from './ChatHeader.module.css';

export interface ChatHeaderProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  variant?: 'default' | 'compact';
  onClose?: () => void;
  className?: string;
}

export function ChatHeader({
  title = 'DevXGPT',
  subtitle,
  actions,
  variant = 'default',
  onClose,
  className = '',
}: ChatHeaderProps) {
  return (
    <header className={`${styles.header} ${styles[variant]} ${className}`}>
      <div className={styles.info}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      <div className={styles.actions}>
        {actions}
        {onClose && (
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            <Icon name="close" size={16} />
          </button>
        )}
      </div>
    </header>
  );
}
